export default function passkeyAvailable(): boolean {
    return typeof window !== 'undefined'
        && typeof window.PublicKeyCredential === 'function'
        && typeof navigator !== 'undefined'
        && typeof navigator.credentials?.get === 'function';
}
